export var BiglakeCatalogMode;
(function (BiglakeCatalogMode) {
    BiglakeCatalogMode["BIGLAKE_CATALOG_MODE_UNSPECIFIED"] = "BIGLAKE_CATALOG_MODE_UNSPECIFIED";
    BiglakeCatalogMode["BIGLAKE_CATALOG_MODE_BQ_FEDERATION"] = "BQ_FEDERATION";
    BiglakeCatalogMode["BIGLAKE_CATALOG_MODE_LAKEHOUSE_CATALOG"] = "LAKEHOUSE_CATALOG";
})(BiglakeCatalogMode || (BiglakeCatalogMode = {}));
